import { pubsub, cart } from '@services';
import { notyf } from '@modules';

class ProductForm extends HTMLElement {
  #unsubscribers = [];
  #form = this.querySelector('form');
  #quantityInput = this.#form.querySelector('input[name="quantity"]');
  // Get all submit buttons that are part of the form
  #submitButtons = document.querySelectorAll(`button[form="${this.#form.getAttribute('id')}"]`);

  connectedCallback() {
    this.#form.addEventListener('submit', (event) => this.#onFormSubmit(event));
    this.upsellProducts = this.#initializeUpsellProducts();
    this.personalizedProduct = null;

    this.#unsubscribers.push(
      pubsub.subscribe('variant:change', ({ id, data: { html } }) => {
        if (id !== this.dataset.productId) return;

        setTimeout(() => {
          const productForm = html.querySelector('product-form').cloneNode(true);
          this.replaceWith(productForm);
        }, 100);
      }),
      pubsub.subscribe('quantity:change', ({ quantity }) => {
        this.#quantityInput.value = quantity;
      })
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  async #onFormSubmit(event) {
    event.preventDefault();
    this.#toggleLoading(true);

    try {
      const items = [...this.upsellProducts];
      if (this.personalizedProduct) items.push(this.personalizedProduct);
      await cart.add({ form: this.#form, items });
    } catch (error) {
      this.#onError(error);
    } finally {
      this.#toggleLoading(false);
    }
  }

  /**
   * Toggle loading state on submit buttons
   * @param {boolean} loading
   */
  #toggleLoading(loading) {
    this.#submitButtons.forEach((button) => button.classList.toggle('loading', loading));
  }

  /**
   * Handle form error
   * @param {Error} error - The error object
   */
  #onError({ message }) {
    notyf.error(message);
  }

  #initializeUpsellProducts() {
    const selectedUpsellInput = this.querySelector('input[name="swiper-upsell-product"]:checked');
    if (!selectedUpsellInput) return [];

    return [
      {
        id: parseInt(selectedUpsellInput.value),
        quantity: parseInt(this.querySelector('input[name="quantity"]').value) || 1,
        parent_id: parseInt(this.querySelector('input[name="variant-id"]').value),
      },
    ];
  }
}

customElements.define('product-form', ProductForm);
